import {
  NavigationProp,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { addDays, format } from "date-fns";
import { useFragment } from "react-relay";

import { useDepartmentMaxGolfCourseBookingWindow } from "@/features/Department/hooks/useDepartmentMaxGolfCourseBookingWindow";
import { useGetClubStartOfWeekNumberPatron } from "@/hooks/useGetClubStartOfWeekNumberPatron";
import { ClubStackNavigatorParamList } from "@/navigators/ClubNavigator";
import { InlineDatePicker } from "@whoosh/design-system/src/components/controls/Datepickers";
import { DayObject } from "@whoosh/design-system/src/components/controls/Datepickers/components/Calendar/types";

import { DepartmentAvailabilityDatePicker_department$key } from "./__generated__/DepartmentAvailabilityDatePicker_department.graphql";

type Props = {
  departmentRef: DepartmentAvailabilityDatePicker_department$key | null;
};
export const DepartmentAvailabilityDatePicker = ({ departmentRef }: Props) => {
  const department = useFragment(
    DepartmentAvailabilityDatePickerFragmentString,
    departmentRef
  );

  const navigation =
    useNavigation<
      NavigationProp<ClubStackNavigatorParamList, "DepartmentAvailability">
    >();

  const route =
    useRoute<
      RouteProp<ClubStackNavigatorParamList, "DepartmentAvailability">
    >();

  const date = route?.params?.date;

  const clubWeekStartsOn = useGetClubStartOfWeekNumberPatron(
    department?.club ?? null
  );

  const windowDays = useDepartmentMaxGolfCourseBookingWindow(
    department ?? null
  );
  const startDate = format(new Date(), "yyyy-MM-dd");
  const endDate = format(addDays(new Date(), windowDays), "yyyy-MM-dd");
  const dateInfo = new Map<string, DayObject>();

  if (date) {
    dateInfo.set(date, { selected: true });
  }

  const onSelectDate = (selectedDate: string) => {
    navigation.setParams({
      date: selectedDate,
    });
  };

  return (
    <InlineDatePicker
      startDate={startDate}
      endDate={endDate}
      onSelectDate={onSelectDate}
      dateInfo={dateInfo}
      selectedDate={date}
      fillEmptyDays
      showDayOfWeekHeader
      clubWeekStartsOn={clubWeekStartsOn}
    />
  );
};

const DepartmentAvailabilityDatePickerFragmentString = graphql`
  fragment DepartmentAvailabilityDatePicker_department on Department {
    ...useDepartmentMaxGolfCourseBookingWindow_department
    club {
      ...useGetClubStartOfWeekNumberPatron_club
    }
  }
`;
